import * as R from "ramda";

const toArray = <T>(iterable: Iterable<T>, options?: { count?: number; filter?: (item: T) => boolean }): T[] => {
	const result: T[] = [];

	const count = options?.count || +Infinity;
	const filter = options?.filter || R.T;

	let i = 0;
	for (const item of iterable) {
		if (filter(item)) {
			result.push(item);

			if (++i === count) {
				break;
			}
		}
	}

	return result;
};

export default toArray;
